import { FC, useRef, useEffect } from 'react';
import { useFormAttachments } from '@frontend/form-packet-selector';
import { useEnhancedSendFormsFlow } from '../../../../hooks/useEnhancedSendFormsFlow';
import { useSendFormsStore } from '../../../../providers/store';

const AttachDocuments: FC = () => {
  const ignoreFirstUpdateRef = useRef(true);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isEnhancedFlowEnabled] = useEnhancedSendFormsFlow();
  const { acceptedFiles, rejectedFiles, setAcceptedFiles, setRejectedFiles, setIsUploadInProgress, locationId } =
    useSendFormsStore([
      'acceptedFiles',
      'rejectedFiles',
      'setAcceptedFiles',
      'setRejectedFiles',
      'setIsUploadInProgress',
      'locationId',
    ]);

  const {
    FormAttachments,
    formAttachmentProps,
    acceptedFiles: acceptedFilesUpdate,
    rejectedFiles: rejectedFilesUpdate,
    isUploadingFiles,
  } = useFormAttachments({
    locationId,
    initialAcceptedFiles: acceptedFiles,
    initialRejectedFiles: rejectedFiles,
    isEnhancedFlowEnabled,
  });

  useEffect(() => {
    // Ignore the first update to prevent the initial state from being set twice
    if (ignoreFirstUpdateRef.current) {
      ignoreFirstUpdateRef.current = false;
      return;
    }

    // Update the store with the latest accepted and rejected files
    setAcceptedFiles(acceptedFilesUpdate);
    setRejectedFiles(rejectedFilesUpdate);
    setIsUploadInProgress(isUploadingFiles);

    // Scroll to the bottom of the container when new files are accepted
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [
    acceptedFilesUpdate,
    rejectedFilesUpdate,
    isUploadingFiles,
    setAcceptedFiles,
    setIsUploadInProgress,
    setRejectedFiles,
  ]);

  return (
    <div ref={containerRef}>
      <FormAttachments {...formAttachmentProps} />
    </div>
  );
};

export default AttachDocuments;
